<template>
  <v-app-bar height="50" class="bg-green-custom position-fixed" elevation="0">
    <div class="d-flex justify-space-between align-center w-100">
      <!-- Logo / Tên hệ thống -->
      <div class="d-flex align-center" :class="!hasMenu ? 'pl-4' : ''">
        <v-btn icon v-if="hasMenu">
          <v-icon class="header-icon" @click="toggleNavbar">mdi-menu</v-icon>
        </v-btn>
        <span class="header-title hide-text">{{ $t('kakusan') }}</span>
        <span class="header-text ml-2 mt_2px hide-text">{{ route.path.includes('/admin') ? $t('admin_header') : $t('prop_header') }}</span>
      </div>

      <!-- Menu góc phải -->
      <div class="d-flex align-center mr-4">
                <VSelectSearchable v-if="showChooseProperty()" v-model="propertyId" :items="propertyList"
                    item-title="property_name" item-value="property_id" variant="outlined" density="compact"
                    hide-details="auto" class="custom-select mr-4 select-width"
                    :placeholder="$t('search_by_facility_name')" :search-placeholder="$t('search_by_facility_name')"
                    @change="changePropertyId" />
        <v-btn class="w-auto header-button-small" v-show="showChooseProperty()" @click="toProp002()">
          <v-icon class="header-icon">mdi-clipboard-text</v-icon>
        </v-btn>
        <v-btn class="w-auto header-button-small" @click="!isAdmin && toProp0013()">
          <v-icon class="header-icon">mdi-account-circle</v-icon>
          <span class="user-name-style text-ellipsis header-text hide-text">{{ username }}</span>
        </v-btn>
        <v-btn class="w-auto header-button-small" @click="logout">
          <v-icon class="header-icon">mdi-logout</v-icon>
          <span class="header-text hide-text">{{ $t('logout') }}</span>
        </v-btn>
      </div>
    </div>
  </v-app-bar>
  <DialogCheckProperty v-model:isVisible="dialogVisible" />
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useNavbarStore } from '@/stores/navbar';
import { useProp000Store } from '~/stores/property-manager/prop-000';
import { API_PROPERTY_MANAGER_000, AUTO_EXPAND_NAME } from '~/constants/property_manager/api-property-manager-000';
import { storeToRefs } from 'pinia';

const prop000Store = useProp000Store();
const { propertyId } = storeToRefs(prop000Store);

const router = useRouter();

const isAdmin = window.location.pathname.startsWith('/admin');
const authStore = isAdmin ? useAdminUserStore() : usePropertyUserStore();

const username = ref<string>('');

const toProp0013 = () => {
  router.push('/property-manager/prop-013');
};

const toProp002 = () => {
  router.push('/property-manager/prop-002');
};

const navbarStore = useNavbarStore();
const toggleNavbar = () => {
  navbarStore.toggleNavbar();
};

const route = useRoute();
const hasMenu = computed(() => {
  return !route.path.includes('/property-manager/prop-002');
});

export interface Property {
  property_id: string;
  property_name: string;
  property_flag: string;
}
const propertyList = ref<Property[]>([]);
let dialogVisible = ref(false);

const initPropertyData = () => {
  const property_list: any = localStorage.getItem(API_PROPERTY_MANAGER_000.PROPERTY_LIST);
  const property_id: any = localStorage.getItem(API_PROPERTY_MANAGER_000.PROPERTY_ID);
  if (isValidValue(property_list)) {
    propertyList.value = JSON.parse(property_list);
    propertyId.value = property_id ? property_id : null;
  }
};

onMounted(async () => {
  initPropertyData();
  if (authStore.isAuthenticated) {
    username.value = authStore.userInfo?.name;
  }
});

watch(
  () => route.fullPath,
  (newPath) => {
    if (newPath.includes('/property-manager/prop-003')) {
      initPropertyData();
    }
  }
);

const changePropertyId = () => {
  const newId = propertyId.value;
  if (newId) {
    const objectFind = propertyList.value.find((res: Property) => res.property_id === newId);
    if (objectFind?.property_flag === '0') {
      dialogVisible.value = true;
      const property_id: any = localStorage.getItem(API_PROPERTY_MANAGER_000.PROPERTY_ID);
      propertyId.value = property_id;
      return;
    }
    localStorage.setItem(API_PROPERTY_MANAGER_000.PROPERTY_ID, newId);
  } else {
    localStorage.removeItem(API_PROPERTY_MANAGER_000.PROPERTY_ID);
  }
  localStorage.setItem('opening_menu', AUTO_EXPAND_NAME);
  location.replace('/property-manager/prop-003');
};

const logout = () => {
  authStore.logout();
};

const showChooseProperty = () => {
  return hasMenu.value && !isAdmin;
};
</script>

<style scoped>
.header-title {
  font-size: 18px;
  color: white;
}

.header-icon {
  color: white;
}

.header-text {
  color: white;
  font-size: 14px;
}

.v-toolbar__content {
  height: 50px;
}

.mt_2px {
  margin-top: 2px;
}

::v-deep(.custom-select .v-field) {
  background: white !important;
  /* Xóa màu nền trắng */
}

.position-fixed {
  position: fixed;
  top: 0;
}

@media (min-width: 1000px) {
  .select-width {
    width: 500px;
  }
  .user-name-style{
    max-width: 200px;
  }
}
@media (max-width: 1000px) {
  .select-width {
    width: 160px;
  }
  .user-name-style{
    max-width: 100px;
  }
}
@media (max-width: 500px) {
  .hide-text {
    display: none !important;
  }
  .header-button-small {
    min-width: 40px;
    padding: 0px;
  }
}
</style>
